<template>
  <div>
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>课程管理</el-breadcrumb-item>
      <el-breadcrumb-item v-if="!this.$route.query.id"
        >新增系列课</el-breadcrumb-item
      >
      <el-breadcrumb-item v-if="this.$route.query.id"
        >编辑系列课</el-breadcrumb-item
      >
    </el-breadcrumb>
    <div class="content" v-loading="loading">
      <div class="left_box">
        <el-form
          label-position="top"
          label-width="80px"
          :model="searchForm"
          :rules="rules"
          ref="ruleForm"
        >
          <el-form-item label="上传视频封面" prop="course_cover_url">
            <el-upload
              class="upload-demo"
              drag
              :show-file-list="false"
              :headers="headersData"
              :action="uploadImgUrl"
              :on-success="handleAvatarSuccessImg"
              :before-upload="beforeAvatarUploadImg"
              v-show="!imageUrl"
              ref="upload"
              :on-progress="uploadImgProcess"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                将图片文件拖到此处，或<em>点击上传</em>
              </div>
              <div class="el-upload__tip" slot="tip">
                推荐图片尺寸300*170px 大小＜30M 格式推荐 png、jpg
              </div>
              <el-progress
                v-if="imgFlag == true"
                slot="tip"
                type="line"
                :percentage="imgUploadPercent"
                style="margin-top: 30px"
              ></el-progress>
            </el-upload>
            <el-image
              style="width: 360px; height: 180px"
              v-show="imageUrl"
              :src="imageUrl"
              :preview-src-list="srcList"
            >
            </el-image>
            <el-upload
              class="upload-demo"
              :headers="headersData"
              :action="uploadImgUrl"
              :show-file-list="false"
              :on-success="handleAvatarSuccessImg"
              :before-upload="beforeAvatarUploadImg"
              :on-progress="uploadImgProcess"
              v-show="imageUrl"
            >
              <div class="el-upload__tip" slot="tip">
                <div>推荐图片尺寸300*170px 大小＜30M 格式推荐 png、jpg</div>
              </div>
              <el-button icon="el-icon-refresh">替换</el-button>
              <el-progress
                v-if="imgFlag == true"
                slot="tip"
                type="line"
                :percentage="imgUploadPercent"
                style="margin-top: 30px"
              ></el-progress>
            </el-upload>
          </el-form-item>
          <el-form-item label="标题" prop="title">
            <el-input
              v-model="searchForm.title"
              type="textarea"
              :rows="3"
              maxlength="80"
              show-word-limit
            ></el-input>
          </el-form-item>
          <el-form-item label="类目选择" prop="cate">
            <el-cascader
              v-model="searchForm.cate"
              :options="cateList"
              :props="cascaderProps"
              placeholder="请选择"
              style="width: 360px"
              clearable
            >
            </el-cascader>
          </el-form-item>
          <el-form-item label="推荐选择位" prop="posid">
            <el-select
              :clearable="true"
              v-model="searchForm.posid"
              placeholder="请选择"
              style="width: 360px"
            >
              <el-option
                v-for="item in posidList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <div style="text-align: center" class="form_btns">
              <el-button @click="goBack">取消</el-button>
              <!-- this.$router.push("/manage_center") -->
              <el-button
                type="goon"
                style="margin-right: 24px"
                @click="submitForm"
                >保存</el-button
              >
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div class="right_box" :key="childKey" v-loading="loding">
        <div class="child_box" v-for="(item, index) in childList" :key="index">
          <div class="title">{{ item.title }}</div>
          <div class="child_form">
            <el-form
              label-position="top"
              label-width="80px"
              :model="item['searchForm_' + item.itemKey]"
              :ref="item['ruleForm_' + item.itemKey]"
              :rules="item['rules_' + item.itemKey]"
            >
              <el-form-item label="上传视频资源" prop="video_url">
                <el-upload
                  class="upload-demo"
                  drag
                  :headers="headersData"
                  :show-file-list="false"
                  :action="uploadImgUrl"
                  :before-upload="
                    (file) => {
                      return beforeVideoUpload(file, item, item.itemKey);
                    }
                  "
                  :on-success="
                    (res, file, fileList) => {
                      handleAvatarSuccess(
                        res,
                        file,
                        fileList,
                        item,
                        item.itemKey
                      );
                    }
                  "
                  v-show="!item.videoUrl"
                  :on-progress="
                    (event, file, fileList) => {
                      uploadVideoProcess(event, file, fileList, item);
                    }
                  "
                >
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text">
                    将视频文件拖到此处，或<em>点击上传</em>
                  </div>
                  <div class="el-upload__tip" slot="tip">只能上传mp4格式</div>
                  <el-progress
                    v-if="item.videoFlag == true"
                    type="line"
                    :percentage="item.videoUploadPercent"
                    slot="tip"
                  ></el-progress>
                </el-upload>

                <video
                  :src="item.videoUrl"
                  style="width: 360px; height: 180px"
                  controls="controls"
                  :id="'upvideo_' + item.itemKey"
                  v-show="item.videoShowFlag"
                >
                  您的浏览器不支持视频播放
                </video>
                <canvas
                  :id="'mycanvas_' + item.itemKey"
                  style="display: none"
                ></canvas>
                <div style="position: relative" v-show="item.cavesSrc">
                  <img :src="item.cavesSrc" alt="" />
                  <div
                    class="video_dialog"
                    @click="
                      openDialog(item['searchForm_' + item.itemKey].video_url)
                    "
                  >
                    <img src="../img/video_play.png" alt="" />
                  </div>
                </div>
                <el-upload
                  class="upload-demo"
                  :headers="headersData"
                  :show-file-list="false"
                  :action="uploadImgUrl"
                  :before-upload="
                    (file) => {
                      return beforeVideoUpload(file, item, item.itemKey);
                    }
                  "
                  :on-success="
                    (res, file, fileList) => {
                      handleAvatarSuccess(
                        res,
                        file,
                        fileList,
                        item,
                        item.itemKey
                      );
                    }
                  "
                  v-show="item.videoUrl"
                  :on-progress="
                    (event, file, fileList) => {
                      uploadVideoProcess(event, file, fileList, item);
                    }
                  "
                >
                  <div class="el-upload__tip" slot="tip">
                    <div class="el-upload__tip" slot="tip">只能上传mp4格式</div>
                  </div>
                  <el-button icon="el-icon-refresh">替换</el-button>
                  <el-progress
                    v-if="item.videoFlag == true"
                    type="line"
                    :percentage="item.videoUploadPercent"
                    slot="tip"
                  ></el-progress>
                </el-upload>
              </el-form-item>
              <el-form-item
                label="标题"
                prop="video_title"
                style="width: 360px"
              >
                <el-input
                  v-model="item['searchForm_' + item.itemKey].video_title"
                  type="textarea"
                  :rows="3"
                  maxlength="80"
                  show-word-limit
                ></el-input>
              </el-form-item>
              <el-form-item>
                <div style="text-align: center; margin-top: 16px">
                  <el-button
                    type="danger"
                    @click="deletItme(index, item.itemKey)"
                    >删除</el-button
                  >
                </div>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div class="child_box add_img">
          <div class="img_title_child">
            <img
              class="add_child"
              src="../img/add_child.png"
              alt=""
              @click="addList"
            />
            <div style="color: #909399; text-align: center">新建章节</div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      title="视频预览"
      :visible.sync="dialogVisible"
      width="840px"
      @close="closeDialog"
    >
      <video
        :src="dialogUrl"
        controls="controls"
        id="dialogvideo"
        style="width: 800px; height: 400px"
      >
        您的浏览器不支持视频播放
      </video>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
      loading: false,
      uploadImgUrl: `${process.env.VUE_APP_PROXY}file/upload`,
      imgFlag: false, // 进度条相关的
      imgUploadPercent: 0, // 进度条相关的
      imageUrl: "",
      searchForm: [],
      childList: [],
      srcList: [],
      searchForm: {
        course_cover_url: "",
        attribute: "2",
        title: "",
        cate: "",
        posid: "",
        series: [],
      },
      file_path: [],
      loding: false,
      cateList: [],
      cascaderProps: {
        value: 'id',
        label: 'cate_name',
        children: 'children'
      },
      posidList: [
        {
          value: 1,
          label: "精品位",
        },
      ],
      rules: {
        course_cover_url: [
          { required: true, message: "请上传视频封面", trigger: "change" },
        ],
        title: [
          { required: true, message: "请填写课程标题", trigger: "change" },
        ],
        cate: [
          { required: true, message: "请选择课程类目", trigger: "change" },
        ],
      },
      dialogUrl: "",
      childKey: 1,
    };
  },
  mounted() {
    this.getCate()
    if (this.$route.query.id) {
      this.init(this.$route.query.id);
    } else {
      let _this = this;
      for (let index = 0; index < 2; index++) {
        let itemKey = _this.randomChar();
        _this.childList.push({
          itemKey: itemKey,
          title: `第${index + 1}节`,
          ["searchForm_" + itemKey]: {
            blues_sort: index + 1,
            video_url: "",
            video_title: "",
            video_file_name: "",
            video_duration: 0,
          },
          ["ruleForm_" + itemKey]: "ruleForm_" + itemKey,
          ["rules_" + itemKey]: {
            video_url: [
              { required: true, message: "请上传视频资源", trigger: "change" },
            ],
            video_title: [
              { required: true, message: "请填写视频标题", trigger: "change" },
            ],
          },
          videoUrl: "",
          videoFlag: false,
          cavesSrc: false,
          videoShowFlag: false,
          videoUploadPercent: 0,
        });
      }
    }
  },
  methods: {
    // 获取课程分类
    async getCate() {
      const [err, res] = await this.$http.get("home/course/cate");
      if (err) {
        return;
      }
      
      // 过滤掉有links_src的子分类，只保留可以添加课程的分类
      const filteredData = (res.list || res).map(category => {
        if (category.children && category.children.length > 0) {
          // 过滤掉有links_src的子分类
          const filteredChildren = category.children.filter(child => !child.links_src);
          
          return {
            ...category,
            children: filteredChildren
          };
        }
        return category;
      });
      
      this.cateList = filteredData;
    },
    randomChar() {
      let x = "0123456789qwertyuioplkjhgfdsazxcvbnm";
      let tmp = "";
      let timestamp = new Date().getTime();
      tmp += x.charAt(Math.ceil(Math.random() * 100000000) % x.length);
      return timestamp + tmp;
    },
    addList() {
      let itemKey = this.randomChar();
      this.childList.push({
        itemKey,
        title: `第${this.childList.length + 1}节`,
        ["searchForm_" + itemKey]: {
          blues_sort: this.childList.length + 1,
          video_url: "",
          video_title: "",
          video_file_name: "",
          video_duration: 0,
        },
        ["ruleForm_" + itemKey]: "ruleForm_" + itemKey,
        ["rules_" + itemKey]: {
          series: [
            { required: true, message: "请上传视频资源", trigger: "change" },
          ],
          video_title: [
            { required: true, message: "请填写视频标题", trigger: "change" },
          ],
        },
        videoUrl: "",
        videoFlag: false,
        cavesSrc: false,
        videoShowFlag: false,
        videoUploadPercent: 0,
      });
    },
    // 上传之前的函数
    beforeVideoUpload(file, data, index) {
      let _this = this;
      return new Promise(async function (resolve, reject) {
        let fileName = file.name || "";
        let ext = fileName.split(".")[fileName.split(".").length - 1];
        _this.videoType = ext;
        let duration, width, height;
        if (ext !== "mp4") {
          _this.$message.error("上传视频应为 mp4 格式!");
          return false;
        }
        if (data["searchForm_" + index].video_url && !_this.$route.query.id) {
          const [err, res] = await _this.$http.post("file/del_File", {
            file_path: data["searchForm_" + index].video_url,
          });
          if (err) {
            return false;
          }
        }
        if (_this.$route.query.id && data["searchForm_" + index].video_url) {
          _this.file_path.push(data["searchForm_" + index].video_url);
        }
        resolve();
      }).catch((err) => {});
    },
    // 上传成功
    handleAvatarSuccess(res, file, fileList, data, index) {
      let ruleName = data["ruleForm_" + index];
      this.$refs[ruleName][0].clearValidate(["series"]);

      data["searchForm_" + index].video_url = res.data.url;
      data["searchForm_" + index].video_duration = res.data.time_log;
      data["searchForm_" + index].video_file_name = res.data.name;

      console.log(this.childList);
      data.videoUrl = URL.createObjectURL(file.raw);
      data.videoFlag = false;
      data.videoUploadPercent = 0;
      ++this.menuKey;
      // 生成视频图片
      data.videoShowFlag = true;
      data.cavesSrc = false;
      const video = document.getElementById("upvideo_" + index); // 获取视频对象
      // const video = document.createElement("video") // 也可以自己创建video
      video.src = URL.createObjectURL(file.raw); // url地址 url跟 视频流是一样的
      var canvas = document.getElementById("mycanvas_" + index); // 获取 canvas 对象
      const ctx = canvas.getContext("2d"); // 绘制2d
      video.crossOrigin = "anonymous"; // 解决跨域问题，也就是提示污染资源无法转换视频
      video.currentTime = 1; // 第一帧
      video.oncanplay = () => {
        canvas.width = video.clientWidth; // 获取视频宽度
        canvas.height = video.clientHeight; //获取视频高度
        // 利用canvas对象方法绘图
        ctx.drawImage(video, 0, 0, video.clientWidth, video.clientHeight);
        // 转换成base64形式
        data.cavesSrc = canvas.toDataURL("image/png"); // 截取后的视频封面
        this.$nextTick(() => {
          data.videoShowFlag = false;
        });
      };
      this.$refs[data["ruleForm_" + index]][0].clearValidate(["video_url"]);
    },
    handleAvatarSuccessImg(res, file) {
      console.log(res);
      this.searchForm.course_cover_url = res.data.url;
      this.imageUrl = URL.createObjectURL(file.raw);
      this.srcList.push(this.imageUrl);
      this.imgFlag = false;
      this.imgUploadPercent = 0;
      ++this.imgKey;
      this.$refs["ruleForm"].clearValidate(["course_cover_url"]);
    },
    async beforeAvatarUploadImg(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 30;
      let flag = true;
      if (!isJPG) {
        flag = false;
        this.videoFlag = false;
        this.imgUploadPercent = 0;
        this.$message.error("上传头像图片只能是 JPG或者PNG 格式!");
        return Promise.reject(flag);
      }
      if (!isLt2M) {
        console.log(2);
        flag = false;
        this.videoFlag = false;
        this.imgUploadPercent = 0;
        this.$message.error("上传头像图片大小不能超过 30MB!");
        return Promise.reject(flag);
      }
      if (this.searchForm.course_cover_url && !this.$route.query.id) {
        console.log(3);
        const [err, res] = await this.$http.post("file/del_File", {
          file_path: this.searchForm.course_cover_url,
        });
        if (err) {
          return false;
        }
      }
      if (this.$route.query.id) {
        this.file_path.push(this.searchForm.course_cover_url);
        console.log(1);
      }
      return flag;
    },
    uploadImgProcess(event, file, fileList) {
      console.log(file);
      this.imgFlag = true;
      this.imgUploadPercent = parseInt(file.percentage);
    },
    uploadVideoProcess(event, file, fileList, data) {
      data.videoFlag = true;
      data.videoUploadPercent = parseInt(file.percentage);
    },
    submitForm() {
      let formName = [];
      this.childList.forEach((item) => {
        let itemKey = item.itemKey;
        formName.push("ruleForm_" + itemKey);
      });
      formName.push("ruleForm");
      if (this.childList.length < 2) {
          this.$message.error("系列课子视频数量必须>=2");
          return
      }
      this.$refs[formName[0]][0].validate((valid) => {
        if (valid) {
          console.log(1);
        } else {
          console.log(2);
        }
      });
      const validates = (item) => {
        return new Promise((resolve, reject) => {
          if (item != "ruleForm") {
            for (let i = 0; i < this.$refs[item].length; i++) {
              this.$refs[item][i].validate((valid) => {
                if (!valid) {
                  reject();
                }
              });
            }
            resolve();
          } else {
            this.$refs[item].validate((valid) => {
              if (valid) {
                resolve();
              } else {
                reject();
              }
            });
          }
        });
      };
      Promise.all(formName.map((item) => validates(item)))
        .then(async () => {
          if (this.$route.query.id) {
            const [err, res] = await this.$http.post("file/del_File", {
              file_path: this.file_path,
            });
            if (err) {
              this.loding = false;
              return false;
            } else {
              this.loading = true;
              this.childList.forEach((item) => {
                let itemKey = item.itemKey;
                this.searchForm.series.push(item["searchForm_" + itemKey]);
              });
              const { searchForm } = this;
              // 提取二级分类ID（数组下标为1的值）
              const submitData = { ...searchForm };
              if (Array.isArray(submitData.cate) && submitData.cate.length > 1) {
                submitData.cate = submitData.cate[1];
              }
              const [err, res] = await this.$http.post("course/update", submitData);
              if (err) {
                this.loading = false;
                this.searchForm.series = []
                return false;
              }
              if (this.$route.query.status === "1") {
                const [err, res] = await this.$http.post("course/shelves", {
                  id: this.$route.query.id,
                  operation: "up",
                });
                if (err) {
                  return;
                }
              }
              this.loading = false;
              this.$message({
                message: "修改成功",
                type: "success",
              });
              this.$router.push("/manage_center");
            }
          } else {
            this.loading = true;
            this.childList.forEach((item) => {
              let itemKey = item.itemKey;
              this.searchForm.series.push(item["searchForm_" + itemKey]);
            });
            const { searchForm } = this;
            // 提取二级分类ID（数组下标为1的值）
            const submitData = { ...searchForm };
            if (Array.isArray(submitData.cate) && submitData.cate.length > 1) {
              submitData.cate = submitData.cate[1];
            }
            const [err, res] = await this.$http.post("course/add", submitData);
            if (err) {
              this.searchForm.series = []
              this.loading = false;
              return false;
            }
            this.loading = false;
            this.$message({
              message: "新增成功",
              type: "success",
            });
            this.$router.push("/manage_center");
          }
        })
        .catch(() => {
          //校验失败时抛出的信息
          this.loding = false;
          this.$message.error("请检查填写信息");
        });
    },
    goBack() {
      this.$router.push("/manage_center");
    },
    openDialog(data) {
      this.dialogUrl = data;
      this.dialogVisible = true;
    },
    closeDialog() {
      let video = document.getElementById("dialogvideo");
      video.pause();
    },
    deletItme(delIndex, itemKey) {
      const h = this.$createElement;
      this.$msgbox({
        title: "确定删除该节课程视频？",
        message: h("p", null, [h("span", null, "操作不可逆，谨慎操作 ")]),
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        confirmButtonClass: "del_message_btn",
      }).then(async () => {
        this.loding = true;
        if (this.childList[delIndex]["searchForm_" + itemKey].video_url) {
          const [err, res] = await this.$http.post("file/del_File", {
            file_path:
              this.childList[delIndex]["searchForm_" + itemKey].video_url,
          });
          if (err) {
            this.loding = false;
            return false;
          }
        }
        let arr = JSON.parse(JSON.stringify([...this.childList]));
        arr.splice(delIndex, 1);
        this.childList = arr.map((item, index) => {
          let itemKey = item.itemKey;
          item.title = `第${index + 1}节`;
          item["searchForm_" + itemKey].blues_sort = index + 1;
          return item;
        });
        console.log(this.childList);
        this.childKey += 1;
        this.loding = false;
      });
    },
    async init(id) {
      this.loding = true;
      const [err, res] = await this.$http.post("course/edit", {
        id,
      });
      if (err) {
        this.loding = false;
        return false;
      }
      this.loding = false;
      this.searchForm.attribute = res.course.attribute;
      this.searchForm.cate = res.course.cate;
      this.searchForm.course_cover_url = res.course.course_cover_url;
      this.searchForm.id = res.course.id;
      this.searchForm.posid = res.course.posid === 0 ? "" : res.course.posid;
      this.searchForm.title = res.course.title;
      this.imageUrl = process.env.VUE_APP_URL + res.course.course_cover_url;
      let _this = this;
      let childList = [];
      for (let index = 0; index < res.series.length; index++) {
        let itemKey = _this.randomChar();
        childList.push({
          itemKey: itemKey,
          title: `第${index + 1}节`,
          ["searchForm_" + itemKey]: {
            id: res.series[index].id,
            blues_sort: res.series[index].blues_sort,
            video_url: res.series[index].video_url,
            video_title: res.series[index].video_title,
            video_file_name: res.series[index].video_file_name,
            video_duration: res.series[index].video_duration,
          },
          ["ruleForm_" + itemKey]: "ruleForm_" + itemKey,
          ["rules_" + itemKey]: {
            video_url: [
              { required: true, message: "请上传视频资源", trigger: "change" },
            ],
            video_title: [
              { required: true, message: "请填写视频标题", trigger: "change" },
            ],
          },
          videoUrl: process.env.VUE_APP_URL + res.series[index].video_url,
          videoFlag: false,
          cavesSrc: false,
          videoShowFlag: true,
          videoUploadPercent: 0,
        });
      }
      this.childList = childList;
      console.log(this.childList);
      this.$nextTick(() => {
        this.childList.forEach((item) => {
          let index = item.itemKey;
          item.videoShowFlag = true;
          item.cavesSrc = false;
          const video = document.getElementById("upvideo_" + index); // 获取视频对象
          // const video = document.createElement("video") // 也可以自己创建video
          let binaryData = [];
          binaryData.push(process.env.VUE_APP_URL + item.video_url);
          window.URL.createObjectURL(
            new Blob(binaryData, { type: "application/zip" })
          );
          let canvas = document.getElementById("mycanvas_" + index); // 获取 canvas 对象
          const ctx = canvas.getContext("2d"); // 绘制2d
          video.crossOrigin = "anonymous"; // 解决跨域问题，也就是提示污染资源无法转换视频
          video.currentTime = 1; // 第一帧
          video.oncanplay = () => {
            canvas.width = video.clientWidth; // 获取视频宽度
            canvas.height = video.clientHeight; //获取视频高度
            // 利用canvas对象方法绘图
            ctx.drawImage(video, 0, 0, video.clientWidth, video.clientHeight);
            // 转换成base64形式
            item.cavesSrc = canvas.toDataURL("image/png"); // 截取后的视频封面
            this.$nextTick(() => {
              item.videoShowFlag = false;
            });
          };
        });
      });
    },
  },
  computed: {
    headersData() {
      const loginToken = localStorage.getItem("token");
      if (!loginToken) {
        // 跳转登录
        this.$router.push("/");
      }
      return {
        Authenticator: loginToken,
      };
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.el-textarea__inner {
  word-break: break-all;
}
.video_dialog {
  position: absolute;
  height: 180px;
  width: 360px;
  top: 0;
  left: 0;
  background: #000;
  opacity: 0.6;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999 !important;

  img {
    width: 46px;
    height: 46px;
  }
}
/deep/.el-upload {
  display: inline;
}
/deep/.el-upload--text {
  display: flex;
  justify-content: center;
  text-align: center;
}
.el-upload__text {
  color: #909399;
}
/deep/.el-form--label-top .el-form-item__label {
  padding: 0;
  font-weight: 400;
  color: #303133;
}
/deep/.el-upload__tip {
  margin: 0;
  text-align: center;
}
.content {
  margin-top: 16px;
  height: 926px;
  display: flex;
  justify-content: space-between;
  border-radius: 6px;
  .left_box {
    width: 472px;
    height: 100%;
    background: #fff;
    display: flex;
    justify-content: center;
    border-radius: 8px;
    padding-top: 90px;
  }
  .right_box {
    padding-left: 16px;
    width: 1200px;
    height: 100%;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    overflow: auto;
    .child_box {
      width: calc(50% - 8px);
      height: 600px;
      background: #ffffff;
      border-radius: 8px 8px 8px 8px;
      margin-bottom: 16px;
      .add_child {
        width: 96px;
        height: 96px;
        cursor: pointer;
      }
    }
    .add_img {
      position: relative;
      .img_title_child{
        text-align: center;
        position: absolute;
        top: calc(50% - 54px);
        left: 50%;
        transform: translate(-50%);
      }
    }
    .title {
      padding: 16px;
      font-weight: 600;
      color: #000000;
      font-size: 16px;
    }
  }
}
.child_form {
  width: 100%;
  display: flex;
  justify-content: center;
}
.form_btns {
  margin-top: 40px;
  .el-button {
    padding: 8px 39px;
  }
  .el-button--goon,
  .el-button--goon:focus,
  .el-button--goon.is-active,
  .el-button--goon:active {
    background: #2ab18b;
    border-color: #2ab18b;
    color: #fff;
  }
  .el-button--goon:hover {
    background: #8cd8da;
    border-color: #8cd8da;
    color: #fff;
  }
}
</style>
<style >
.del_message_btn {
  background-color: #f56c6c !important;
  border-color: #f56c6c !important;
}
</style>